<template>
  <div class="md-layout">
    <template>
      <div
        v-if="isProgress"
        class="md-layout-item md-size-100 md-small-size-100 bar-progress"
      >
        <md-progress-bar
          class="bar-progress"
          md-mode="indeterminate"
        ></md-progress-bar>
      </div>
    </template>
    <div class="md-layout-item md-xlarge-size-70 md-small-size-100 mx-auto">
      <md-card>
        <md-card-header>
          <div class="card-icon">
            <md-icon>person</md-icon>
          </div>
          <h4 class="title">
            Users List
            <md-button
              class="md-icon-button md-dense md-raised md-primary"
              @click="loadUsers"
            >
              <md-icon>cached</md-icon>
            </md-button>
            <md-button
              class="md-dense "
              :class="{ 'md-primary ': currentPage.active == 1 }"
              @click="filterUsers(1)"
            >
              Active
            </md-button>
            <md-button
              class="md-dense"
              :class="{ 'md-primary': currentPage.active == 0 }"
              @click="filterUsers(0)"
            >
              Deactivated
            </md-button>
          </h4>
          <md-button
            title="add new user"
            class="md-just-icon md-button md-just-icon md-theme-default md-primary more-user"
            @click="showDialogMoreUser()"
          >
            <md-icon>add_circle</md-icon>
          </md-button>
        </md-card-header>
        <md-card-content>
          <!-- USERS TABLE-->
          <md-table
            v-model="users"
            class="paginated-table table-striped table-hover"
            :md-sort.sync="currentPage.orderBy"
            :md-sort-order.sync="currentPage.orderFlow"
            :md-sort-fn="sort"
          >
            <md-table-toolbar>
              <md-field>
                <label for="pages">Per page</label>
                <md-select
                  v-model="currentPage.perPage"
                  name="pages"
                  @md-selected="loadUsers()"
                >
                  <md-option
                    v-for="item in perPageOptions"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                    {{ item }}
                  </md-option>
                </md-select>
              </md-field>

              <div class="md-table-toolbar-end">
                <form
                  style="display:flex; margin-right:0.75rem;"
                  @submit.prevent="search()"
                >
                  <md-field style="margin-right:0px">
                    <md-input
                      v-model="currentPage.search"
                      type="search"
                      clearable
                      style="width: 200px"
                      placeholder="Search records"
                    >
                    </md-input>
                  </md-field>
                  <md-button class="md-success md-just-icon" @click="search()">
                    <md-icon>
                      search
                    </md-icon>
                  </md-button>
                </form>
              </div>
            </md-table-toolbar>
            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell md-label="Name" md-sort-by="name">{{
                item.name
              }}</md-table-cell>
              <md-table-cell
                class="lowercase"
                md-label="Email"
                md-sort-by="email"
                ><span class="email">{{ item.email }}</span>
              </md-table-cell>
              <md-table-cell md-label="Rol" md-sort-by="role_id">{{
                item.role_name
              }}</md-table-cell>
              <md-table-cell md-label="DID">
                {{ item.did ? formatNumber(item.did) : '-' }}
              </md-table-cell>
              <md-table-cell md-label="Active">
                <md-checkbox v-model="item.active">Active</md-checkbox>
              </md-table-cell>
              <md-table-cell md-label="Actions">
                <div class="actions">
                  <md-button
                    title="edit user "
                    :disabled="item.deleted_at != null"
                    class="md-just-icon md-button md-theme-default md-warning"
                    @click="editUser(item)"
                  >
                    <md-icon class="md-icon md-icon-font md-theme-default"
                      >edit</md-icon
                    >
                  </md-button>
                  <md-button
                    :title="
                      item.deleted_at == null ? 'Disable user' : 'Enable user'
                    "
                    class="md-just-icon  md-button  md-theme-default"
                    :class="
                      item.deleted_at == null ? 'md-danger' : 'md-primary'
                    "
                    @click="alertNotication(item)"
                  >
                    <md-icon>{{
                      item.deleted_at != null ? 'add' : 'remove_circle'
                    }}</md-icon>
                  </md-button>
                  <md-button
                    v-if="!item.approved_at"
                    title="enable user"
                    class="md-just-icon  md-button md-just-icon md-theme-default md-primary"
                    @click="statusUser(item.id)"
                  >
                    <md-icon class="md-icon md-icon-font md-theme-default "
                      >info</md-icon
                    >
                  </md-button>
                  <md-button
                    v-else
                    title="user enabled"
                    class="md-just-icon md-button md-just-icon md-theme-default md-default"
                  >
                    <md-icon class="md-icon md-icon-font md-theme-default"
                      >check_circle</md-icon
                    >
                  </md-button>
                </div>
              </md-table-cell>
            </md-table-row>
          </md-table>
          <!-- END OF USERS TABLE-->
          <div
            v-if="!isProgress && users.length == 0"
            class="md-body md-text-center p-4"
          >
            No users found
          </div>
        </md-card-content>
        <md-card-actions md-alignment="space-between">
          <div class="">
            <p class="card-category">
              Showing {{ currentPage.from }} to {{ currentPage.to }} of
              {{ currentPage.total }} entries
            </p>
          </div>
          <pagination
            v-model="currentPage.page"
            class="pagination-no-border pagination-success"
            :per-page="currentPage.perPage"
            :total="currentPage.total"
            @input="loadUsers()"
          >
          </pagination>
        </md-card-actions>
      </md-card>
      <!-- NEW USER MODAL-->
      <template>
        <md-dialog
          :md-backdrop="true"
          class="users-dialog"
          :md-active.sync="showDialog"
        >
          <p class="m-0 md-title md-title-custom-for-user-form">Add New User</p>
          <UserForm
            @saving="isProgress = $event"
            @saved="userSaved($event)"
            @error="notifyVueError($event)"
            @cancel="showDialog = false"
          />
        </md-dialog>
      </template>
      <!-- END OF NEW USER MODAL-->

      <!-- EDIT USER MODAL-->
      <template>
        <md-dialog
          class="md-dialog  md-small-size-100"
          :md-fullscreen="false"
          :md-active.sync="showDialogEdit"
        >
          <md-dialog-title class="">
            <span>Edit User {{ myUser }} </span>
          </md-dialog-title>
          <md-dialog-content class="user-form-container">
            <collapse
              class="user-edit-form "
              :collapse="['Update data user', 'Update Password']"
              icon="keyboard_arrow_down"
              color-collapse="success"
            >
              <template slot="md-collapse-pane-1">
                <UserForm
                  :user="edit"
                  @saving="isProgress = $event"
                  @saved="userSaved($event)"
                  @error="notifyVueError($event)"
                  @cancel="showDialog = false"
                />
              </template>
              <template slot="md-collapse-pane-2">
                <div class="md-layout md-gutter">
                  <div class="md-layout-item md-small-size-100 md-size-50">
                    <md-field>
                      <label>New Password</label>
                      <md-input
                        ref="new_password"
                        v-model="new_password"
                        type="password"
                      ></md-input>
                    </md-field>
                  </div>
                  <div class="md-layout-item md-small-size-100 md-size-50">
                    <md-field>
                      <label>Confirmation Password</label>
                      <md-input
                        ref="confirmation_password"
                        v-model="confirmation_password"
                        type="password"
                      ></md-input>
                    </md-field>
                  </div>
                  <div class="md-layout-item md-small-size-100 md-size-100">
                    <md-button
                      :disabled="isDisabledbtn"
                      class="md-primary mt-4"
                      @click="updatePassword()"
                      >Update Password</md-button
                    >
                  </div>
                </div>
              </template>
            </collapse>
          </md-dialog-content>

          <md-dialog-actions>
            <md-button @click="showDialogEdit = false">Close</md-button>
          </md-dialog-actions>
        </md-dialog>
      </template>
      <!-- END OF EDIT USER MODAL-->
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import Swal from 'sweetalert2'
import { Pagination } from '@/components'
import json from './../../../../timezones.json'
import { Collapse } from '@/components'
import Users from '@/api/users'
import UserForm from '@/components/UsersForm.vue'
import { formatNumber } from '@/api/events'
export default {
  name: 'EditProfileForm',
  components: {
    Collapse,
    UserForm,
    Pagination
  },
  data() {
    return {
      perPageOptions: [5, 10, 25, 50],
      titleuser: '',
      isProgress: false,
      rateName: '',
      showDialog: false,
      showDialogEdit: false,
      isDisabledbtn: false,
      agentRates: [],
      users: [],
      roles: [],
      edit: {},
      currentRol: null,
      current_password: null,
      new_password: null,
      confirmation_password: null,
      checkbox: true,
      myUser: '',
      currentPage: {
        active: 1,
        perPage: 25,
        page: 1,
        search: null,
        orderBy: 'updated_at',
        orderFlow: 'desc',
        from: 0,
        to: 0,
        total: 0,
        lastPage: 0
      }
    }
  },

  watch: {
    showDialog() {
      this.clearDialog()
    }
  },
  created() {},
  mounted() {
    this.loadUsers()
    this.loadRoles()
    this.time_zone = json
  },
  methods: {
    formatNumber,
    clearDialog() {
      this.currentRol = null
      this.myUser = null
      this.id = null
      this.name = null
      this.email = null
      this.zone = null
      this.role_id = null
      this.password = null
      this.passwordconfirmation = null

      this.getTimezone()
    },
    async getTimezone() {
      let ipgeolocationUrl =
        'https://api.ipgeolocation.io/ipgeo?apiKey=e43f9aa965fe4ec3942d0443341a4d24'
      return await axios
        .get(ipgeolocationUrl)
        .then(response => {
          console.log('response:', response)
          let timezone = response.data.time_zone.name
          console.log('timezone', timezone)
          this.zone = timezone
          return timezone
        })
        .catch(err => {
          console.log('error:', err)
          //if the api fails try to get it from the browser
          //return Intl.DateTimeFormat().resolvedOptions().timeZone;
        })
    },
    udpate_timezone(newValue) {
      this.edit.zone = newValue
    },
    udpate_zone(newValue) {
      this.zone = newValue
    },
    userSaved(message) {
      this.loadUsers()
      this.notifyVueSuccess(message)
      this.isProgress = false
      this.isDisabledbtn = false
      this.showDialog = false
      this.showDialogEdit = false
    },
    loadUsers() {
      this.isProgress = true
      Users.index(this.currentPage)
        .then(response => {
          this.isProgress = false
          this.users = response.data.data
          this.users.map(user => {
            user.active = user.deleted_at == null
          })
          this.currentPage.from = response.data.from
          this.currentPage.to = response.data.to
          this.currentPage.total = response.data.total
        })
        .catch(error => {
          console.log(error)
          this.isProgress = false
          this.notifyVueError(error.response.data.message)
        })
      /*let url = process.env.VUE_APP_API_URL + '/users/index'
      axios
        .get(url, {
          headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + this.$store.state.token
          }
        })
        .then(response => {
          this.isProgress = false
          this.users = response.data.users

          this.users.forEach((item, index, users) => {
            users[index].active = item.deleted_at == null
          })
        })
        .catch(error => {
          this.isProgress = false
          this.notifyVueError(error.response.data.message)
        })*/
    },
    sort(value) {
      console.log(value)
      this.loadUsers()
      return this.ratesList
    },
    loadRoles() {
      let url = process.env.VUE_APP_API_URL + '/roles/index'
      axios
        .get(url, {
          headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + this.$store.state.token
          }
        })
        .then(response => {
          this.roles = response.data.roles
        })
        .catch(error => {
          this.notifyVueError(error.response.data.message)
        })
    },
    alertNotication(item) {
      let action = item.deleted_at == null ? 'deactivated' : 'restore'
      Swal.fire({
        title: 'Are you sure?',
        text: 'The user will be ' + action + '!',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'Cancel',
        confirmButtonClass: 'md-button md-success',
        cancelButtonClass: 'md-button md-danger',
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.removeRestoreUser(item)
        }
      })
    },
    removeRestoreUser(item) {
      this.isProgress = true
      let url = ''
      if (item.deleted_at == null) {
        //if user is active
        url = process.env.VUE_APP_API_URL + '/users/delete'
      } else {
        url = process.env.VUE_APP_API_URL + '/users/restore'
      }
      axios
        .post(
          url,
          {
            id: item.id
          },
          {
            headers: {
              Accept: 'application/json',
              Authorization: 'Bearer ' + this.$store.state.token
            }
          }
        )
        .then(response => {
          this.loadUsers()
          this.notifyVueSuccess(response.data.message)
          this.isProgress = false
        })
        .catch(error => {
          this.loadUsers()
          this.notifyVueError(error.response.data.message)
          this.isProgress = false
        })
    },

    showDialogMoreUser() {
      this.clearDialog()
      this.showDialog = true
    },
    parseRates(rates) {
      //console.log('rates', rates)
      return rates ? rates.map(r => r.id) : []
    },
    editUser(item) {
      this.currentRol = item.role_id
      this.myUser = item.name
      this.edit = {
        ...item,
        rates: this.parseRates(item.rates),
        phone: formatNumber(item.phone),
        did: formatNumber(item.did),
        rol: item.role_id
      }
      this.showDialogEdit = true
    },
    updateuserData() {
      let url = process.env.VUE_APP_API_URL + '/users/update'
      if (this.edit.id && this.edit.name && this.validEmail(this.edit.email)) {
        this.isProgress = true
        axios
          .post(
            url,
            {
              ...this.edit,
              rol: this.edit.role_id ? this.edit.role_id : this.currentRol,
              timezone: this.edit.zone
            },
            {
              headers: {
                Accept: 'application/json',
                Authorization: 'Bearer ' + this.$store.state.token
              }
            }
          )
          .then(response => {
            this.loadUsers()
            this.notifyVueSuccess(response.data.message)
            this.isProgress = false
            this.showDialogEdit = false
          })
          .catch(error => {
            this.notifyVueError(error.response.data.message)
            this.isProgress = false
          })
      } else {
        this.notifyVueError('All fields are required')
        this.isProgress = false
      }
    },

    validateData() {
      if (this.howcreateuser == '' || !this.howcreateuser) {
        this.notifyVueError('How do you want to create the user?')
        return false
      }

      if (this.name == '' || this.name == null) {
        this.notifyVueError(' The name field is required')
        this.$refs.name.$el.focus()
        return false
      } else if (!this.validEmail(this.email)) {
        this.notifyVueError(' Enter an email with an appropriate format')
        this.$refs.email.$el.focus()
        return false
      } else if (this.role_id == '') {
        this.notifyVueError(' The rol field is required')
        return false
      } else if (this.password === '') {
        this.notifyVueError(' The password field is required')
        return false
      } else {
        return true
      }
    },
    validEmail(email) {
      // eslint-disable-next-line no-useless-escape
      let emailRegex = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i
      if (emailRegex.test(email)) {
        return true
      } else {
        return false
      }
    },
    updatePassword() {
      if (this.validatePassord()) {
        this.isProgress = true
        let url = process.env.VUE_APP_API_URL + '/users/update/password'
        axios
          .post(
            url,
            {
              id: this.edit.id,
              new_password: this.new_password,
              confirmation_password: this.confirmation_password,
              token: this.$store.state.token
            },
            {
              headers: {
                Accept: 'application/json',
                Authorization: 'Bearer ' + this.$store.state.token
              }
            }
          )
          .then(response => {
            this.notifyVueSuccess(response.data.message)
            this.isProgress = false
          })
          .catch(error => {
            this.notifyVueError(error.response.data.message)
            this.isProgress = false
          })
      }
    },
    statusUser(id) {
      Swal.fire({
        title: 'Are you sure?',
        text: 'The user will be enable!',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'Cancel',
        confirmButtonClass: 'md-button md-success',
        cancelButtonClass: 'md-button md-danger',
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.enableUser(id)
        }
      })
    },
    enableUser(id) {
      let url = process.env.VUE_APP_API_URL + '/users/update/enable'
      this.isProgress = true
      axios
        .post(
          url,
          {
            id: id
          },
          {
            headers: {
              Accept: 'application/json',
              Authorization: 'Bearer ' + this.$store.state.token
            }
          }
        )
        .then(response => {
          this.loadUsers()
          this.notifyVueSuccess(response.data.message)
          this.isProgress = false
        })
        .catch(error => {
          this.notifyVueError(error.response.data.message)
          this.isProgress = false
        })
    },
    validatePassord() {
      if (this.new_password == '' || this.new_password == null) {
        this.notifyVueError(' The field new password is required')
        this.$refs.new_password.$el.focus()
        return false
      } else if (
        this.confirmation_password == '' ||
        this.confirmation_password == null
      ) {
        this.notifyVueError(' The field new password is required')
        this.$refs.confirmation_password.$el.focus()
        return false
      } else if (this.new_password != this.confirmation_password) {
        this.notifyVueError(
          ' The password and the confirmation password do not match'
        )
      } else {
        return true
      }
    },
    filterUsers(active) {
      this.currentPage.active = active
      this.loadUsers()
    },
    notifyVueError(text) {
      this.$notify({
        message: '<b>Ups! </b>' + text + '',
        icon: 'add_alert',
        horizontalAlign: 'right',
        verticalAlign: 'top',
        type: 'danger'
      })
    },
    notifyVueSuccess(text) {
      this.$notify({
        message: '<b>Success! </b>' + text + '',
        icon: 'add_alert',
        horizontalAlign: 'right',
        verticalAlign: 'top',
        type: 'success'
      })
    },
    search() {
      this.loadUsers()
    }
  }
}
</script>

<style lang="scss" scoped>
.md-table-cell.lowercase .md-table-cell-container {
  text-transform: lowercase !important;
}
.md-menu-content.md-select-menu {
  z-index: 12;
  min-width: fit-content;
}

/*.md-dialog {
  width: 50% !important;
}
*/

/*
.md-table-cell-container {
  text-transform: capitalize;
}*/

.more-user {
  position: absolute !important;
  right: 10px;
  border-radius: 100%;
  top: 10px !important;
}

.btnbutton {
  float: right !important;
}

.darken {
  background-color: burlywood;
  color: black;
  padding: 5px;
  border-radius: 5px;
}

@media (max-width: 768px) {
  .md-dialog {
    width: 100% !important;
  }
}

.user-form {
  .md-layout-item {
    padding-right: 1rem;
  }
}
.user-edit-form {
  .md-collapse {
    &-content {
      padding: 0px;
    }
  }
}

.md-dialog /deep/.md-dialog-container {
  max-width: 600px;
  width: 100%;
}

.md-collapse-content {
  padding: 0px;
}

.email {
  word-break: break-all;
}
</style>
